export default __webpack_public_path__ + "static/media/2021_CV.1a2cbbee.pdf";